import { Cache } from '@urql/exchange-graphcache';
import { OrganizationEmailsDocument } from 'generated/graphql';

export const cacheUpdates = {
	Mutation: {
		upsertArtist: (result, args, cache, info) => {
			// const bookerArtists = cache.resolve('Query', 'bookerArtists');

			// if (Array.isArray(bookerArtists)) {
			// 	cache.link('Query', 'bookerArtists', [...bookerArtists, result.upsertArtist]);
			// }

			cache.invalidate('bookerArtists');
		},

		upsertRequest: (result, args, cache, info) => {
			// const bookerArtists = cache.resolve('Query', 'bookerArtists');

			// if (Array.isArray(bookerArtists)) {
			// 	cache.link('Query', 'bookerArtists', [...bookerArtists, result.upsertArtist]);
			// }
			console.log('REQUESTS');
			console.log(args);
			console.log(result);
			console.log(cache);
			console.log(info);

			cache.invalidate('requests');
		},

		// deleteOrganizationEmail: (result, args, cache, info) => {
		// 	// TODO: NEFUNGUJEE
		// 	cache.invalidate('organizationEmails');
		// },

		upsertOrganizationEmail(result, args, cache: Cache, info) {
			cache.updateQuery({ query: OrganizationEmailsDocument }, (data) => {
				if (!data || !result.upsertOrganizationEmail) return null;

				const index = data.organizationEmails.findIndex(
					(organizationEmail) => organizationEmail.id === result.upsertOrganizationEmail.id,
				);

				if (index === -1) {
					return {
						organizationEmails: [...data.organizationEmails, result.upsertOrganizationEmail],
					};
				}

				const newOrganizationEmails = [...data.organizationEmails];
				newOrganizationEmails[index] = result.upsertOrganizationEmail;

				return {
					organizationEmails: newOrganizationEmails,
				};
			});
		},

		deleteOrganizationEmail(result, args, cache: Cache, info) {
			cache.updateQuery({ query: OrganizationEmailsDocument }, (data) => {
				if (!data || !result.deleteOrganizationEmail) {
					return data;
				}

				return {
					organizationEmails: data.organizationEmails.filter(
						(organizationEmail) => organizationEmail.id !== result.deleteOrganizationEmail.id,
					),
				};
			});
		},
	},
};
